<script setup>
import { ref, computed } from "vue";
import { RouterView, useRouter } from "vue-router";
import { useSidenavbarStore } from "@/stores/sidenavbar.js";

const sidenavbarStore = useSidenavbarStore();
const router = useRouter();
const isLogin = computed(() => router.currentRoute.value.path === '/login');
const isRecover = computed(() => router.currentRoute.path === 'recover-account');
const loginStyle = computed(() => {
  if (isLogin.value || isRecover) {
    return {
      paddingLeft: '0dvw'
    }
  }
})

const isLogged = computed(() => {
  const excludedRoutes = [
    "login",
    "register",
    "logout",
    "invitations",
    "activate",
    "recoverAccount",
    "brandLogin",
    "acceptUser",
    "passwordRecovery",
  ];
  return !excludedRoutes.includes(router.currentRoute.value.name);
});

let yautyData = ref('');
if (localStorage.getItem('yautyData')) {
  yautyData = JSON.parse(localStorage.getItem('yautyData'));
}
const emit = defineEmits(["animateSidebar"]);
function animateSidebar() {
  emit("animateSidebar");
}
</script>

<template>
  <div ref="wrapperRef" :style="loginStyle" class="app__content"
    :class="[sidenavbarStore.isCollapse ? '' : 'extended-wrapper', (yautyData.name && isLogged) ? 'wrapper' : 'no-wrapper']"
    :key="$route.fullPath" @callback="handleCallback">
    <RouterView :key="$route.fullPath" @animateSidebar="animateSidebar" />
  </div>
  <div class="orientation-modal">
    <div class="orientation-content">
      <p>{{ $t('orientation.modal') }}</p>
    </div>
  </div>
</template>

<style lang="scss">
@import 'src/styles/colors.scss';

.orientation-modal {
  display: none;
}

/* Estils per a mòbils en horitzontal*/
@media (max-width: 950px) and (orientation: landscape) {
  .wrapper {
    padding: 0 !important;
    margin: 0 !important;
    min-height: 100dvh !important;
    width: 100vw !important;
    max-width: 100vw !important;
    box-sizing: border-box !important;
  }

  .app__content,
  .no-wrapper {
    padding: 0 !important;
    margin: 0 !important;
    width: 100vw !important;
    max-width: 100vw !important;
    box-sizing: border-box !important;
  }

  .extended-wrapper {
    padding: 0 !important;
    margin: 0 !important;
  }

  .container,
  .custom-container {
    max-width: 100vw !important;
    width: 100vw !important;
    padding-left: 10px !important;
    padding-right: 10px !important;
    margin: 0 !important;
    box-sizing: border-box !important;
  }
}

.wrapper {
  padding-left: 5dvw !important;
  min-height: 91.45dvh;
  transition: 0.7s;
  background-color: $layout-background;

  @media (min-width: 769px) and (max-width: 1367px) and (orientation: landscape) {
    padding-left: 6dvw;
  }
}

.no-wrapper {
  min-height: calc(100vh - 60px);
}

.extended-wrapper {
  padding-left: 210px;
  transition: 0.7s;
}

/* moviles */
@media (max-width: 576px) {
  .wrapper {
    display: flex;
    flex-direction: column;
  }

  .app__content,
  .wrapper {
    padding-left: 0 !important;
    min-height: 95.5dvh !important;
  }

  .no-wrapper {
    min-height: 100% !important;
  }
}

@media (min-width: 577px) and (max-width: 750px) and (orientation: portrait) {

  .app__content,
  .wrapper {
    padding-left: 0 !important;
  }

  .no-wrapper {
    min-height: 100% !important;
  }
}

@media (min-width: 1200px) and (max-width: 1299px) and (orientation: landscape) {
  .no-wrapper {
    display: flex;
    justify-content: center;
    align-items: center;
    min-height: 50% !important;
    flex-grow: 1;
  }
}

@media (min-width: 750px) and (max-width: 1300px) and (orientation: portrait) {
  .no-wrapper {
    display: flex;
    justify-content: center;
    align-items: center;
    min-height: 50vh !important;
    height: 89vh !important;
    flex-grow: 1;
  }
}

@supports (-moz-appearance: none) {
  /* Firefox detecta la pantalla algo mes petita i necessitem que entri a la query */
  @media (min-width: 700px) and (max-width: 1300px) and (orientation: portrait) {
    .no-wrapper {
      display: flex;
      justify-content: center;
      align-items: center;
      min-height: 50vh !important;
      height: 90vh !important;
      flex-grow: 1;
    }
  }

  @media (min-width: 769px) and (max-width: 1367px) and (orientation: landscape) {
    .no-wrapper {
      min-height: calc(100vh - 100px) !important;
    }
  }
}

@supports (-webkit-touch-callout: none) {
  @media (max-width: 950px) and (orientation: landscape) {
    .app__content,
    .wrapper,
    .no-wrapper {
      min-height: 100lvh !important;
    }
  }
}

@media (min-width: 769px) and (max-width: 1367px) and (orientation: landscape) {
  .wrapper {
    padding-left: 7.5dvw !important;
    @media (max-width: 1024px) {
      padding-left: 0dvw !important;
    }
  }
}

@media (min-width:700px) and (orientation: portrait) {
  .wrapper {
    padding-left: 0 !important;
  }
}

@media (max-width: 950px) and (orientation:landscape) {
  .wrapper {
    padding-left: 0 !important;
  }
}
</style>